import React, { useState } from 'react';
import { api } from '../lib/api';
import { T, serif, sans, Boton, Campo, estiloInput, Aviso } from '../lib/ui';

export function Login({ onEntrar }) {
  const [usuario, setUsuario] = useState('');
  const [clave, setClave] = useState('');
  const [error, setError] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const entrar = async (e) => {
    e.preventDefault();
    setError(''); setOcupado(true);
    try {
      const r = await api.login(usuario.trim(), clave);
      onEntrar(r.usuario);
    } catch (err) {
      // Distinguir la causa importa: "no se pudo conectar" para todo
      // deja al usuario sin saber si escribio mal la clave o si el
      // servidor esta mal configurado.
      if (err.message === 'credenciales_invalidas') {
        setError('Usuario o contraseña incorrectos.');
      } else if (err.status === 500 || err.message === 'error_interno') {
        setError('El servidor respondió con un error. Suele ser la conexión con la base de datos: abre /api/health/db para ver el detalle.');
      } else if (err.status) {
        setError(`El servidor respondió ${err.status}. Avisa a IT con este dato.`);
      } else {
        setError('No hay conexión con el servidor. Revisa tu internet e inténtalo otra vez.');
      }
      setOcupado(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: T.navy, padding: 20,
    }}>
      <div style={{ width: '100%', maxWidth: 380 }}>
        <div style={{ textAlign: 'center', marginBottom: 32 }}>
          {/* El azul del logo sobre el fondo navy queda por debajo del
              contraste minimo legible, asi que va sobre placa blanca.
              Asi se conservan los colores de marca sin perder nitidez. */}
          <div style={{
            display: 'inline-block', background: '#fff', borderRadius: 12,
            padding: '18px 26px', marginBottom: 18,
            boxShadow: '0 8px 24px rgba(0,0,0,.22)',
          }}>
            <img src="/marca/logo-acceso.png" alt="SICREA"
                 style={{ height: 62, display: 'block' }} />
          </div>
          <div style={{
            fontFamily: serif, fontSize: 38, fontWeight: 700, color: T.brass,
            fontStyle: 'italic', lineHeight: 1,
          }}>
            RINDE
          </div>
          <div style={{ color: T.brass, fontSize: 12, marginTop: 10, letterSpacing: '.12em' }}>
            RENDICIÓN DE GASTOS
          </div>
        </div>

        <form onSubmit={entrar} style={{ background: T.paper, borderRadius: 12, padding: 26 }}>
          {error && <Aviso tipo="bad">{error}</Aviso>}

          <Campo etiqueta="Usuario">
            <input
              value={usuario} onChange={(e) => setUsuario(e.target.value)}
              autoCapitalize="none" autoCorrect="off" autoFocus
              placeholder="nombre.apellido" style={estiloInput}
            />
          </Campo>

          <Campo etiqueta="Contraseña">
            <input
              type="password" value={clave} onChange={(e) => setClave(e.target.value)}
              style={estiloInput}
            />
          </Campo>

          <Boton type="submit" disabled={ocupado || !usuario || !clave}
                 style={{ width: '100%', padding: 12, marginTop: 6 }}>
            {ocupado ? 'Entrando…' : 'Entrar'}
          </Boton>
        </form>

        <p style={{ textAlign: 'center', color: T.brass, fontSize: 11, marginTop: 18, fontFamily: sans }}>
          SICREA PERÚ S.A.C. · rinde.sicrea.net
        </p>
      </div>
    </div>
  );
}

export function CambiarPassword({ usuario, onListo }) {
  const [nueva, setNueva] = useState('');
  const [repetir, setRepetir] = useState('');
  const [error, setError] = useState('');
  const [ocupado, setOcupado] = useState(false);

  const guardar = async (e) => {
    e.preventDefault();
    if (nueva !== repetir) return setError('Las contraseñas nuevas no coinciden.');
    if (nueva.length < 10) return setError('La contraseña nueva debe tener al menos 10 caracteres.');

    setError(''); setOcupado(true);
    try {
      // Sin la anterior: en el cambio obligatorio el servidor no la pide.
      await api.cambiarPassword(undefined, nueva);
      // Cambiar la contraseña cierra todas las sesiones: hay que volver a entrar.
      const r = await api.login(usuario.username, nueva);
      onListo(r.usuario);
    } catch (err) {
      // Cada motivo con su nombre. Antes todo lo que no fuera la clave
      // actual caía en "No se pudo cambiar la contraseña", y quien se
      // quedaba trabado no tenía manera de saber si el problema era el
      // largo, repetir la misma, o de verdad la clave vieja.
      setError({
        password_actual_incorrecta:
          'La contraseña actual no es correcta. Si te la restablecieron, '
          + 'usa la temporal que te dieron, no la que usabas antes.',
        password_debil:
          'La contraseña nueva es muy corta: tiene que tener al menos '
          + '10 caracteres.',
        password_repetida:
          'La contraseña nueva no puede ser la misma que ya tenías. '
          + 'Elige otra distinta.',
        sin_conexion: 'Sin conexión. Revisa la señal y vuelve a intentar.',
        sin_respuesta: 'El servidor no respondió. Vuelve a intentar.',
      }[err.message] || 'No se pudo cambiar la contraseña.');
      setOcupado(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh', display: 'flex', alignItems: 'center',
      justifyContent: 'center', background: T.navy, padding: 20,
    }}>
      <form onSubmit={guardar} style={{
        background: T.paper, borderRadius: 12, padding: 26, width: '100%', maxWidth: 400,
      }}>
        <h2 style={{ fontFamily: serif, fontSize: 24, color: T.navy, margin: '0 0 6px' }}>
          Cambia tu contraseña
        </h2>
        <p style={{ color: T.muted, fontSize: 13, margin: '0 0 20px' }}>
          Hola {usuario.nombre}. Elige una contraseña tuya para continuar.
          No hace falta la anterior.
        </p>

        {error && <Aviso tipo="bad">{error}</Aviso>}

        {/* Aquí iba "Contraseña actual". Se quitó: en este punto la
            anterior es una clave temporal que le dictaron hace un
            minuto, y pedírsela dejaba a la persona trabada en esta
            misma pantalla sin poder avanzar.

            No se pierde seguridad: para llegar hasta aquí ya tuvo que
            entrar con esa temporal. */}
        <Campo etiqueta="Contraseña nueva" ayuda="Mínimo 10 caracteres.">
          <input type="password" value={nueva} onChange={(e) => setNueva(e.target.value)}
                 autoFocus style={estiloInput} />
        </Campo>
        <Campo etiqueta="Repite la contraseña nueva">
          <input type="password" value={repetir} onChange={(e) => setRepetir(e.target.value)}
                 style={estiloInput} />
        </Campo>

        <Boton type="submit" disabled={ocupado} style={{ width: '100%', padding: 12 }}>
          {ocupado ? 'Guardando…' : 'Guardar y continuar'}
        </Boton>
      </form>
    </div>
  );
}
